import { serviceRequest } from 'utils/http';
import { ReferralService } from 'common/api';
import { REFERRAL_SOURCE_EXTERNAL } from 'services/referrals/referral-source.constants';

export function getReferralAPI(id: string, isExternalReferral = false) {
  return serviceRequest(() =>
    ReferralService.referralControllerGetForCurrentUser(
      id,
      isExternalReferral ? REFERRAL_SOURCE_EXTERNAL : undefined
    )
  );
}
